import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import * as React from 'react';
import { useEffect, useState } from 'react';
import NotificationService, {
  Notification,
  NotificationSeverity
} from '../../services/NotificationService';

const timeout = 6000;

const PageNotification = () => {
  const [notification, setNotification] = useState<Notification>(null);
  const [closeTimer, setCloseTimer] = useState(null);

  useEffect(() => {
    NotificationService.on('show', (notification) => {
      setNotification(notification);
    });
  }, []);

  useEffect(() => {
    if (notification) {
      if (closeTimer) {
        clearTimeout(closeTimer);
      }
      const newCloseTimer = setTimeout(() => {
        setNotification(null);
      }, timeout);
      setCloseTimer(newCloseTimer);
    }
  }, [notification]);

  const severity = (() => {
    switch ((notification || {}).severity) {
      case NotificationSeverity.ERROR:
        return 'warning';
      case NotificationSeverity.SUCCESS:
        return 'success';
      default:
        return 'info';
    }
  })();

  if (notification == null) {
    return null;
  }

  return (
    <Snackbar open={true}>
      <Alert severity={severity}>{notification.message}</Alert>
    </Snackbar>
  );
};

export default PageNotification;
